<script setup>
import { defineEmits, defineProps } from "vue";

const props = defineProps({
  listDetail: {
    type: Object,
    required: true,
  },
});

console.log(props.data);

function formatDate(dateString) {
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const date = new Date(dateString);
  return date.toLocaleDateString("es-ES", options);
}

const emit = defineEmits(["close"]);
const closeOffcanvas = () => {
  emit("close");
};
</script>
<template>
  <article>
    <h5 class="create-title mt-1 mb-4">Detalle de Lista:</h5>
    <div class="details-container">
      <h6
        class="form-label globals-label text-capitalize"
        style="
          font-weight: 800;
          text-align: start;
          font-size: x-large;
          margin-bottom: 1rem;
        "
      >
        {{ listDetail.name }}
      </h6>
      <div class="details-row">
        <h5 class="form-label globals-label">Descripción:</h5>
        <p>
          {{ listDetail.description }}
        </p>
      </div>
      <div class="details-row">
        <h5 class="form-label globals-label">Estatus:</h5>
        <p>{{ listDetail.status }}</p>
      </div>
      <div class="details-row">
        <h5 class="form-label globals-label">Actualización:</h5>
        <p style="text-transform: capitalize">
          {{ formatDate(listDetail.date) }}
        </p>
      </div>
      <!-- <div class="details-row">
        <h5 class="form-label globals-label">Encriptada:</h5>
        <p>No</p>
      </div>
      <div class="details-row">
        <h5 class="form-label globals-label">Vista Previa:</h5>
        <ul class="list-group list-group-flush column-text">
          <li class="list-group-item">Elemento 1</li>
          <li class="list-group-item">Elemento 2</li>
          <li class="list-group-item">Elemento 3</li>
        </ul>
      </div> -->
      <div class="d-flex justify-content-center my-5">
        <button
          class="globals-button"
          @click="closeOffcanvas"
          data-bs-dismiss="offcanvas"
        >
          Cerrar
        </button>
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
article {
  padding: 0rem 1rem 0 1rem;
}
.details-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.details-row {
  display: flex;
  gap: 3rem;
}

.details-row h5 {
  font-size: larger;
  width: 200px;
  flex-shrink: 0;
}

.details-row p,
.details-row ul {
  flex: 1;
  margin-bottom: 0;
}
p {
  color: $six-color;
  text-align: left;
}
.column-text {
  border-radius: 10px;
  font-size: smaller;
  font-weight: 400;
  margin-top: 10px;
}
li {
  background-color: $shadow-gray-color;
  padding-right: 1rem;
  color: $primary-color;
}
</style>
